import * as Endpoints from '../Entities/EndPoints'
import Axios from '../Axios'

const API = Axios.getInstance

export const getTimelineByRiskId = (riskId) => {
    let url = Endpoints.GET_TIMELINE_BY_RISK_ID
    url = url.replace('{riskId}', riskId)

    return API(Endpoints.API_ENDPOINT)
        .get(url)
        .then((response) => response)
        .catch((err) => ({ err }))
}
